var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === 'ready')?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):(_vm.status === 'loading')?_c('loading'):(_vm.status === 'error')?_c('cannot-start',{attrs:{"error":_vm.error}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }